import type { BlockExportMapping } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { aboutUsBlocks } from "./AboutUs";
import { blogBlocks } from "./Blog";
import { blogListingBlocks } from "./BlogListing";
import { callToActionBlocks } from "./CallToAction";
import { contactBlocks } from "./Contact";
import { contentBlocks } from "./Content";
import { homepageBlocks as evergreenHomepageBlocks } from "./Evergreen/Homepage";
import { featureCardBlocks } from "./FeatureCards";
import { headingsBlocks } from "./Headings";
import { homepageBlocks } from "./Homepage";
import { pricingBlocks } from "./Pricing";
import { homepageBlocks as professionalNetworkHomepageBlocks } from "./ProfessionalNetwork/Homepage";
import { Root } from "./Root";
import { salesBlocks } from "./Sales";
import { sectionBlocks } from "./Sections";
import { testimonialBlocks } from "./Testimonials";

export const defaultBlocks: BlockExportMapping = {
  root: Root,
  ...sectionBlocks,
  ...callToActionBlocks,
  ...featureCardBlocks,
  ...contentBlocks,
  ...headingsBlocks,
  ...testimonialBlocks,
  ...homepageBlocks,
  ...salesBlocks,
  ...aboutUsBlocks,
  ...pricingBlocks,
  ...blogListingBlocks,
  ...blogBlocks,
  ...contactBlocks,
  ...professionalNetworkHomepageBlocks,
  ...evergreenHomepageBlocks,
};
